
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { ColorEnum } from '../../../enums'
import { EpbBadge } from '../../shared'

export default defineComponent({
  name: 'ToolReportingAsideSection',
  components: {
    EpbBadge,
  },
  props: {
    title: {
      type: String as PropType<string>,
      required: true,
    },
    helpMessage: {
      type: String as PropType<string>,
      required: false,
    },
  },
  setup() {
    const baseClass = 'epb-tool-reporting-aside-section'
    return {
      baseClass,
      ColorEnum,
    }
  },
})
